import * as React from "react";
const SvgFiBrandsCcDinersClub = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M12.64 6.364V17.6a6.03 6.03 0 0 0 3.866-5.617 6.03 6.03 0 0 0-3.866-5.62m-8.173 5.618a6.03 6.03 0 0 0 3.863 5.615V6.365a6.03 6.03 0 0 0-3.863 5.617m8.173-5.618V17.6a6.03 6.03 0 0 0 3.866-5.617 6.03 6.03 0 0 0-3.866-5.62m-8.173 5.618a6.03 6.03 0 0 0 3.863 5.615V6.365a6.03 6.03 0 0 0-3.863 5.617m8.686-10.355h-2.69C4.724 1.626 0 5.905 0 12.09c0 5.66 4.724 10.31 10.463 10.283h2.69C18.824 22.373 24 17.748 24 12.09c0-6.188-5.176-10.464-10.847-10.463m-2.667 19.849a9.495 9.495 0 0 1-9.495-9.494 9.497 9.497 0 0 1 9.495-9.497 9.5 9.5 0 0 1 9.496 9.497c-.001 5.244-4.251 9.493-9.496 9.494M12.64 6.364V17.6a6.03 6.03 0 0 0 3.866-5.617 6.03 6.03 0 0 0-3.866-5.62m-8.173 5.618a6.03 6.03 0 0 0 3.863 5.615V6.365a6.03 6.03 0 0 0-3.863 5.617"
    />
  </svg>
);
export default SvgFiBrandsCcDinersClub;
